import React from "react";

import { cn } from "src/utils/cn";

export function ShellContainer({ children, className }) {
  return (
    <div
      className={cn(
        "flex h-dvh min-h-dvh w-full items-stretch gap-2 overflow-hidden bg-gray-50 p-2",
        className
      )}
    >
      {children}
    </div>
  );
}
